import { ObjectImage } from "#src/common/system/Object";
import { useAppSelector } from "#src/store/hooks";
import { ChevronSelectorVertical } from "@untitled-ui/icons-react";
import { useRef, useState } from "react";
import { SidebarSettingMenu } from "./SettingMenu";
import { useClickOutside } from "#src/hooks/uiHelpers/useClickOutside";

export const LayoutV2SidebarUserProfile = ({
  workspaceId,
  minified,
  active,
}: {
  workspaceId: string;
  minified: boolean;
  active: boolean;
}) => {
  const userInfo = useAppSelector((state) => state.auth.userInfo);

  // --------------- REFS & STATES ---------------

  const settingButtonRef = useRef<HTMLLabelElement>(null);
  const menuContainerRef = useRef<HTMLDivElement>(null);

  const [openMenu, setOpenMenu] = useState<boolean>(false);

  // --------------- EFFECTS ---------------

  useClickOutside([settingButtonRef, menuContainerRef], () => {
    setOpenMenu(false);
  });

  // --------------- RENDER ---------------

  return (
    <label
      ref={settingButtonRef}
      className={`outline outline-1 bg-white shadow-xs rounded-xl flex gap-2 relative cursor-pointer ${
        minified ? "outline-transparent px-0.5 py-3" : "outline-gray-v2-200 p-3"
      }`}
    >
      {userInfo ? (
        <>
          <ObjectImage
            data={userInfo.avatar}
            className={`h-10 w-10 min-w-10 rounded-full outline ${active ? "outline-brand-v2-700" : "outline-transparent"}`}
          />
          <div
            className={`flex flex-col ${minified ? "w-0 overflow-hidden opacity-0" : "w-full"}`}
          >
            <span className="font-semibold text-sm whitespace-nowrap">
              {userInfo.full_name}
            </span>
            <span className="text-sm whitespace-nowrap">
              {userInfo.username}
            </span>
          </div>
        </>
      ) : null}
      <button
        className={`absolute top-1.5 right-1.5 h-8 w-8 ${minified ? "opacity-0 appearance-none" : ""}`}
        onClick={() => {
          setOpenMenu(true);
        }}
      >
        <ChevronSelectorVertical className="h-5 w-5" />
      </button>
      <SidebarSettingMenu
        containerRef={menuContainerRef}
        open={openMenu}
        onChangeOpen={(value) => {
          setOpenMenu(value);
        }}
        workspaceId={workspaceId}
      />
    </label>
  );
};
